import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import React, { useCallback, useMemo, useState } from "react";
import { View, FlatList } from "react-native";
import ListTile from "./components/ListTile";
import { getRoutingList } from "@services/api";
import { useFocusEffect } from "@react-navigation/native";

const Routing = ({ navigation, route }) => {
  const [data, setData] = useState({});
  const { nav_params } = route.params;
  const fetchData = async () => {
    try {
      // eslint-disable-next-line no-shadow
      const { data } = await getRoutingList();
      setData(data?.data);
    } catch (error) {
      console.error("Error fetching Routing List: ", error);
    }
  };

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );
  const listData = useMemo(
    () => [
      {
        title: "Assign Routes",
        type: "ASSIGN_ROUTES",
        subtitle_1: "Pending Customers :",
        subtitle_1_value: data?.routing_pending_cx,
        nav_to: "CpDeliveryRoutes",
      },
      {
        title: "Manage Routes",
        type: "MANAGE_ROUTES",
        subtitle_1: "DB Unassigned Routes:",
        subtitle_1_value: data?.routing_unassigned_cpdb_routes,
        nav_to: "DeliveryRouteList",
      },
    ],
    [data, nav_params],
  );

  const renderItem = ({ item }) => <ListTile item={item} />;

  return (
    <View style={{ flex: 1, backgroundColor: "#fff" }}>
      <HeaderWithBackAndTitle
        headertitle="Routing"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      <FlatList
        data={listData}
        keyExtractor={(item) => item.type}
        renderItem={renderItem}
      />
    </View>
  );
};
export default Routing;
